const { useRef } = require("react")

export const useRandomId = () => {
  const id = useRef(Math.random().toString(36).substring(2, 15))
  return id.current
}
